// extracted by mini-css-extract-plugin
export default {"recommended":"recommended_recommended__c7I9b","recommended__title":"recommended_recommended__title__PF07u","recommended__list":"recommended_recommended__list__R7+sz"};